import React from "react";

const Engineer = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_2219_5263)">
      <rect x="4" y="4" width="16" height="16" rx="4" fill="#EDEEFF" />
    </g>
    <path
      d="M10.5 13.5C9.165 13.5 6.5 14.17 6.5 15.5V16.5H14.5V15.5C14.5 14.17 11.835 13.5 10.5 13.5ZM7.5 15.5C7.61 15.14 9.155 14.5 10.5 14.5C11.85 14.5 13.4 15.145 13.5 15.5H7.5ZM8.37 10.5H8.5C8.5 11.605 9.395 12.5 10.5 12.5C11.605 12.5 12.5 11.605 12.5 10.5H12.63C12.765 10.5 12.875 10.39 12.875 10.255V10.245C12.875 10.18 12.8492 10.1177 12.8032 10.0718C12.7573 10.0258 12.695 10 12.63 10H12.5C12.5 9.26 12.095 8.625 11.5 8.275V8.75C11.5 8.89 11.39 9 11.25 9C11.11 9 11 8.89 11 8.75V8.07C10.84 8.03 10.675 8 10.5 8C10.325 8 10.16 8.03 10 8.07V8.75C10 8.89 9.89 9 9.75 9C9.61 9 9.5 8.89 9.5 8.75V8.275C8.905 8.625 8.5 9.26 8.5 10H8.37C8.33783 10 8.30597 10.0063 8.27624 10.0186C8.24652 10.031 8.21951 10.049 8.19676 10.0718C8.17401 10.0945 8.15596 10.1215 8.14365 10.1512C8.13134 10.181 8.125 10.2128 8.125 10.245V10.26C8.125 10.39 8.235 10.5 8.37 10.5ZM11.5 10.5C11.5 11.05 11.05 11.5 10.5 11.5C9.95 11.5 9.5 11.05 9.5 10.5H11.5ZM16.99 9.115L17.455 8.7L17.08 8.05L16.485 8.245C16.415 8.19 16.335 8.145 16.25 8.11L16.125 7.5H15.375L15.25 8.11C15.165 8.145 15.085 8.19 15.01 8.245L14.42 8.05L14.045 8.7L14.51 9.115C14.5 9.2 14.5 9.29 14.51 9.375L14.045 9.8L14.42 10.45L15.02 10.26C15.085 10.31 15.16 10.35 15.235 10.385L15.375 11H16.125L16.26 10.39C16.34 10.355 16.41 10.315 16.48 10.265L17.075 10.455L17.45 9.805L16.985 9.38C17 9.285 16.995 9.2 16.99 9.115V9.115ZM15.75 9.875C15.5842 9.875 15.4253 9.80915 15.3081 9.69194C15.1908 9.57473 15.125 9.41576 15.125 9.25C15.125 9.08424 15.1908 8.92527 15.3081 8.80806C15.4253 8.69085 15.5842 8.625 15.75 8.625C15.9158 8.625 16.0747 8.69085 16.1919 8.80806C16.3092 8.92527 16.375 9.08424 16.375 9.25C16.375 9.41576 16.3092 9.57473 16.1919 9.69194C16.0747 9.80915 15.9158 9.875 15.75 9.875ZM15.7 11.395L15.275 11.535C15.225 11.495 15.17 11.465 15.11 11.44L15.02 11H14.485L14.395 11.435C14.335 11.46 14.275 11.495 14.225 11.53L13.805 11.39L13.535 11.855L13.865 12.15C13.86 12.215 13.86 12.275 13.865 12.335L13.535 12.64L13.805 13.105L14.235 12.97C14.285 13.005 14.335 13.035 14.39 13.06L14.48 13.5H15.015L15.11 13.065C15.165 13.04 15.22 13.01 15.27 12.975L15.695 13.11L15.965 12.645L15.635 12.34C15.64 12.275 15.64 12.215 15.635 12.155L15.965 11.86L15.7 11.395ZM14.75 12.695C14.505 12.695 14.305 12.495 14.305 12.25C14.305 12.005 14.505 11.805 14.75 11.805C14.995 11.805 15.195 12.005 15.195 12.25C15.195 12.495 14.995 12.695 14.75 12.695Z"
      fill="#5F67E0"
    />
    <defs>
      <filter
        id="filter0_d_2219_5263"
        x="0"
        y="0"
        width="24"
        height="24"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2219_5263"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2219_5263"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default Engineer;
